import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonIcon, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { Store } from "react-notifications-component";
import { getLanguage } from "../../../utils/environment";
import {
  addTagToList,
  closeCreateTagModal,
  setSelectedTags,
} from "../../Tags/redux/actions";
import { createNewTag } from "../../Tags/service/tags.service";

const lan = getLanguage();

const Index = (props) => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [formData, setFormData] = useState({
    tagName: {
      key: "tagName",
      label: "Tag Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const { isOpenCreateTagModal } = useSelector(
    ({ tagsReducer }) => tagsReducer
  );

  const { selectedTags } = useSelector(({ tagsReducer }) => tagsReducer);

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateForm);
    }
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setFormData(updateForm);
  };

  const onClickCreate = async () => {
    setIsLoading(true);

    const updateForm = { ...formData };

    let body = {
      tag_name: updateForm.tagName.value,
    };

    try {
      const response = await createNewTag(body);
      setIsLoading(false);

      if (response?.data) {
        dispatch(addTagToList(response.data));
        // dispatch(setSelectedTags([...selectedTags, tagData]));
        Store.addNotification({
          title: "Success!",
          message: "Tag Created Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
        dispatch(closeCreateTagModal());
      }
    } catch (error) {
      console.log("Error creating Tag");
      Store.addNotification({
        title: "Error!",
        message: "Tag Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      clearAll();
    }
  };

  const updateForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenCreateTagModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container w-400 center_me d-flex flex-column  animate__animated  ${
          isOpenCreateTagModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeCreateTagModal())}
          />
        </div>
        <div className="hne-create-tag-wrapper">
          <FormHeader
            data={{
              formHeader: "Create Tags",
              size: "md-md",
            }}
          />
          <div className="hne-tag-header-wrapper">
            <InputBox
              data={updateForm.tagName}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateForm.tagName.key);
              }}
            />
          </div>

          <Button
            data={{
              btnName: "DONE",
              buttonType:
                updateForm.tagName.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable: updateForm.tagName.value === "" ? true : false,
            }}
            onClick={async (e) => {
              e.preventDefault();

              await onClickCreate(e);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default Index;
